import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import CtaButton from '@components/CtaButton/CtaButton'

import circle from '@static/vectors/circle-chart.svg'
import appImage from '@static/images/hero-banner/slide2.jpg'
import guy from '@static/images/ecomerce/ecomerce-guy.webp'
import './Ecomerce.css'

export default function Ecomerce() {
  return (
    <section id="ecomerce" className="landing-section">
      <div className="container">
        <img className="circle-chart" src={circle} alt="circle chart" />
        <h1>
          <MarkdownMessage id="home.ecomerce.title" />
        </h1>
        <p>
          <FormattedMessage id="home.ecomerce.text" />
        </p>
        <CtaButton />
        <video autoPlay muted loop playsInline poster={appImage}>
          <source src="d" type="video/mp4" />
          <img src={appImage} alt="app animation fallback" />
        </video>
        <img className="ecomerce-guy" src={guy} alt="guy with a laptop" />
      </div>
    </section>
  )
}
